/* istanbul ignore file */
import { DefaultDropdownProps, Dropdown } from 'framework/form';
import { ACTIVE_STATUS, FUTURE_STATUS } from '../assignmentService';
import { DropDownFilter } from 'framework/list';

interface AssignmentStatusFilterProps extends DefaultDropdownProps {
  value?: string;
}

const AssignmentStatusFilter = (props: AssignmentStatusFilterProps) => {
  return (
    <DropDownFilter {...props}>
      <Dropdown
        {...props}
        placeholder="Select status"
        options={[
          { value: ACTIVE_STATUS, label: 'Active' },
          { value: FUTURE_STATUS, label: 'Future' },
        ]}
      />
    </DropDownFilter>
  );
};

export default AssignmentStatusFilter;
